import * as React from 'react';
import ModuleData from "./ModuleData";
import ResizeControls from "../../components/ResizeControls";
import SyncPosition, {PositionBox} from "../../components/SyncPosition";
import ModuleOverlay from "../../overlay/components/ModuleOverlay";

import { EditViewProps } from "../interfaces";

export interface SpacerInPlaceEditViewProps extends EditViewProps<ModuleData>, React.Props<SpacerInPlaceEditView> {
}

export default class SpacerInPlaceEditView extends React.Component<SpacerInPlaceEditViewProps, {}> {

    static MAX_HEIGHT = 400;
    static MIN_HEIGHT = 10;

    render() {
        const modulEl = document.getElementById(`modul_${this.props.moduleId}`);

        return (
            <SyncPosition element={modulEl} position="absolute">
            {
                (box: PositionBox) => {
                    return (
                        <ResizeControls
                            dataTestId="module-spacer-resize"
                            width={box.width}
                            height={box.height}
                            top={box.top}
                            left={box.left}
                            position="absolute"
                            zIndex={ModuleOverlay.ZINDEX + 1}
                            resizeControls={["S"]}
                            onResize={this.onResize}
                            pointerEventsNone={false}
                        />
                    );
                }
            }
            </SyncPosition>
        );
    }

    private onResize = (dx: number, dy: number, pos: string) => {
        this.setHeight(Math.round(this.props.payload.heightInPixels + dy));
    };

    private setHeight(value: number) {
        value = Math.max(SpacerInPlaceEditView.MIN_HEIGHT, Math.min(SpacerInPlaceEditView.MAX_HEIGHT, value));
        this.props.onDataChange(
            {
                heightInPixels: value
            } as ModuleData
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/spacer/InPlaceEditView.tsx
 **/